import { useEffect, useState } from "react"
import { fetchEditFolder, fetchGetSubFolders } from "../FolderApi"
import { toast } from "react-toastify"
import Folder from "./Folder"
import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../../services/i18n/i18nSlice"
import { DraggableFolder, Grid } from "../_draggable/DraggableFolder"

import {
  DndContext,
  closestCenter,
  MouseSensor,
  TouchSensor,
  DragOverlay,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy
} from '@dnd-kit/sortable';
import { prepareFolderData } from "../folderUtils"

export default function SubFolders ({parentFolder, additionalElement=null, showAdditionalElement=false}) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const hasContent = parentFolder?.files?.length > 0 || parentFolder?.video?.length > 0 || parentFolder?.links?.length > 0
    const [subFolders, setSubFolders] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [activeId, setActiveId] = useState(null);

    const loadSubFolders = async () => {
        setIsLoading(true)
        const response = await fetchGetSubFolders({parent_folder_id: parentFolder?.folder_id})
        if (response.success){
            setSubFolders(response.data.folders)
            setIsLoading(false)
        } else {
            toast.error(t.training.error_loading_folder)
        }
    } 

    useEffect(( )=>{
        loadSubFolders()
    },[parentFolder.folder_id])

    const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));

    function handleDragStart(event) {
        setActiveId(event.active.id);
    }

    function handleDragEnd(event) {
        const {active, over} = event;

        let old_element = null
        let old_element_before = null
        let current_element = null

        if (active.id !== over.id) {
            setSubFolders((items) => {
                const oldIndex = items.findIndex(f => f.folder_id === active.id);
                const newIndex = items.findIndex(f => f.folder_id === over.id);
                
                current_element =  structuredClone(items[oldIndex])
                old_element = structuredClone(items[newIndex])
                old_element_before = structuredClone(items[newIndex > 0 ? newIndex-1 : 0 ])
                return arrayMove(items, oldIndex, newIndex);
            });
            handleSwapFolder(current_element, old_element, old_element_before)
        }

        setActiveId(null);
    }

    function handleDragCancel() {
        setActiveId(null);
    }

    const handleSwapFolder = async (folderData, old_element, old_element_before) => {
        let _folderData = prepareFolderData(folderData, true)
        _folderData['priority'] = (old_element.priority !== 0 ? (old_element.priority + old_element_before.priority)/2 : -0.5)
        const response = await fetchEditFolder({folder_id: _folderData.folder_id}, _folderData)
        if(response.success){
            toast.success('Posizione aggiornata')
        } else {
            toast.error("Errore nell'aggiornamento della posizione")
        }
    }

    return(
        <div>
            {!subFolders.length > 0 ? additionalElement : null}
            <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragStart={handleDragStart}
                onDragEnd={handleDragEnd}
                onDragCancel={handleDragCancel}
                >
                <SortableContext items={subFolders} strategy={rectSortingStrategy}>
                    <Grid columns={3}>
                        {subFolders?.map((folder, folder_id)=>{
                            return (
                                <DraggableFolder
                                    folder={folder} 
                                    hasContent={hasContent}
                                    index={folder_id}
                                    key={folder_id}
                                />
                            )
                        })}
                        {subFolders.length > 0 && showAdditionalElement > 0 ? additionalElement : null}
                    </Grid>
                </SortableContext>

                <DragOverlay adjustScale={true}>
                    {activeId ? (
                        <Folder isDragging={true} folder={subFolders.find(f => f.folder_id === activeId)} index={subFolders.findIndex(f => f.folder_id === activeId)} />
                    ) : null}
                </DragOverlay>
                </DndContext>
            {isLoading && Array.from(Array(3), (v,i)=> <Folder key={i}/>)}
        </div>
    )
}